import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
    name: 'user',
    initialState: {
        value: 0,
        jwt: localStorage.getItem('jwt'),
        userDetails: {},
        credits: 0
    },
    reducers: {
        setJwt: (state, action) => {
            localStorage.setItem('jwt', action?.payload?.token);
            state.jwt = action?.payload?.token;
        },
        setUserDetails: (state, action) => {
            state.userDetails = action.payload
        },
        logout: (state) => {
            localStorage.removeItem('jwt')
            state.jwt = ''
            state.userDetails = {}
        }
    }
})

export const { setJwt, setUserDetails, setCredits, logout } = userSlice.actions;
export default userSlice.reducer;